import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import downloadicon from './images/downloadIcon.svg';

const buttonDownload = (props) => {
  return (
    <button className='btn-download' onClick={() => props.onclick()}>
      <span>{props.text}</span>
      {props.icon ? props.icon : <Image src={downloadicon} alt='להורדה' />}
    </button>
  );
};

export default buttonDownload;
